import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useCreateProjectMutation } from "../../../redux/slices/projectApiSlice";
import { LoadingButton } from "@mui/lab";

const SimpleAddWebsiteForm = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [createWebsite, { isLoading }] = useCreateProjectMutation(); // same API hook, just renamed locally

  return (
    <Formik
      initialValues={{ url: "" }}
      validationSchema={Yup.object({
        url: Yup.string()
          .url(t("Invalid URL", "URL invalide"))
          .required(t("URL is required", "L'URL est obligatoire")),
      })}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          const res = await createWebsite(values).unwrap(); // sends { url }
          toast.success(t("Website created successfully", "Site Web créé avec succès"));
          resetForm();
          if (onSuccess) onSuccess(res);
        } catch (error) {
          toast.error(
            t("Error creating website", "Une erreur est survenue lors de la création du site Web")
          );
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ handleSubmit, handleChange, values, errors, touched, isSubmitting }) => (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="url" className="block text-sm font-medium text-gray-700">
              {t("Website URL", "URL du site Web")}
            </label>
            <input
              id="url"
              name="url"
              type="text"
              value={values.url}
              onChange={handleChange}
              placeholder="https://example.com"
              className="mt-1 block w-full rounded-md border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500 text-sm"
            />
            {errors.url && touched.url && (
              <p className="text-red-500 text-xs mt-1">{errors.url}</p>
            )}
          </div>

          <div className="w-full">
            <LoadingButton
              type="submit"
              loading={isLoading || isSubmitting}
              variant="contained"
              sx={{
                textTransform: "none",
                bgcolor: "#8b5cf6",
                "&:hover": {
                  bgcolor: "#7c3aed",
                },
              }}
              fullWidth
            >
              {t("Create Website", "Créer un site Web")}
            </LoadingButton>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default SimpleAddWebsiteForm;
